export function decToHexa(dec: number): string {
  return dec.toString(16);
}

export function hexaToDec(hex: string) {
  if (/^[0-9a-fA-F]+$/.test(hex)) {
    return parseInt(hex, 16);
  }
  return hex;
}
export function hexatoAscii(hex: string) {
  // Initialize an empty string to store the resulting ASCII characters
  let str = "";
  // Iterate through the hexadecimal string, processing two characters at a time
  for (let n = 0; n < hex.length; n += 2) {
    // Extract two characters from the hexadecimal string and convert them to their ASCII equivalent
    str += String.fromCharCode(parseInt(hex.substring(n, n + 2), 16));
  }
  // Return the resulting ASCII string
  return str;
}
